function isObject(value) {
  return value && typeof value === 'object' && value.constructor === Object;
}

function isArray(value) {
  return Array.isArray(value);
}

export default casifyString => (
  function applyCasify(value) {
    // on arrays we apply casify on each element, keys stay the same
    function casifyArray(array) {
      return array.map(applyCasify);
    }

    // on objects we apply casify on each property and the key is casified
    function casifyObject(object) {
      const copy = {};
      const keys = Object.keys(object);
      keys.forEach((key) => {
        const newKey = casifyString(key);
        copy[newKey] = applyCasify(object[key]);
      });
      return copy;
    }

    if (isObject(value)) {
      return casifyObject(value);
    } if (isArray(value)) {
      return casifyArray(value);
    }
    return value;
  }
);
